var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.customClass,attrs:{"disabled":_vm.busy,"type":_vm.type}},[(_vm.busy)?_c('span',[_c('span',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status","aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.loadText)+" ")]):_c('span',[_vm._v(" "+_vm._s(_vm.Text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }